import { render, staticRenderFns } from "./TabCard.vue?vue&type=template&id=6ad2fbae&scoped=true"
import script from "./TabCard.vue?vue&type=script&lang=js"
export * from "./TabCard.vue?vue&type=script&lang=js"
import style0 from "./TabCard.vue?vue&type=style&index=0&id=6ad2fbae&prod&lang=less&scoped=true"
import style1 from "./TabCard.vue?vue&type=style&index=1&id=6ad2fbae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad2fbae",
  null
  
)

export default component.exports